module.exports = __webpack_public_path__ + "img/batyam-header.783ad6ef.svg";